module.exports = __webpack_public_path__ + "static/media/uncheck.96eac77b.svg";